import React from 'react'

export default {
  nobr: (...chunks) => <span key={chunks[0] || Math.random()} className="u-nobr">{chunks}</span>,
  block: (...chunks) => <span key={chunks[0] || Math.random()} className="u-block">{chunks}</span>,
  p: (...chunks) => <p key={chunks[0] || Math.random()}>{chunks}</p>,
}
